export default [
  {
    path: '/Users/',
    name: 'Users',
  },
];
